import { createGlobalStyle } from 'styled-components'

const StyledGlobalStyle = createGlobalStyle`
/* ============================================================
   Échelle typographique centralisée.
   Texte de LECTURE (résumés, auteurs, labels) : taille fixe,
   ne scale pas avec la fenêtre. Seuls les TITRES restent
   responsives, bornés haut et bas par clamp().
   ============================================================ */
:root {
    --fs-small: 15px;
    --fs-body: 17px;
    --fs-card-title: clamp(16px, 2.8vmin, 28px);
    --fs-title: clamp(20px, 3.5vmin, 34px);
    --fs-title-thin: clamp(17px, 3vmin, 28px);
}

@media only screen and (max-width: 767px) {
    :root {
        --fs-small: 12px;
        --fs-body: 13px;
        --fs-title: 24px;
        --fs-title-thin: 16px;
    }

    /* En mobile ces classes restent en graisse normale (rendu d'origine) */
    .text-petit-bold,
    .text-moyen-bold {
        font-weight: normal;
    }
}

img {
    vertical-align: 0 !important;
}
body {
    background-color: rgb(39, 36, 36) !important;
}

.text-petit-bold {
    font-size: var(--fs-small);
    font-weight: bold;
}

.text-moyen-bold {
    font-size: var(--fs-body);
    font-weight: bold;
}

`

function GlobalStyle() {
    return <StyledGlobalStyle />
}

export default GlobalStyle
